import { EditGroupsTableQuery } from '@website/types/graphqlOperations';
import React, { useState } from 'react';
import AddOrEditGroupItemForm from './AddOrEditGroupItemForm';
import { GroupRowView } from './GroupRowView';

interface GroupRowProps {
  group: EditGroupsTableQuery['trip']['groups']['items'][0];
  position: any;
  commissions: EditGroupsTableQuery['trip']['commissionOverrides'];
  trip: Pick<
    EditGroupsTableQuery['trip'],
    'id' | 'startTimezone' | 'endTimezone'
  >;
  host: EditGroupsTableQuery['trip']['host'];
}

/**
 * Group Row
 *
 * Shows the group details, or if in 'editing mode' it will show a group edit form.
 */
export default function GroupRow({
  group,
  position,
  commissions,
  trip,
  host,
}: GroupRowProps) {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <>
      {isEditing && (
        <AddOrEditGroupItemForm
          commissions={commissions}
          group={group}
          host={host}
          position={position}
          trip={trip}
          onHide={() => setIsEditing(!isEditing)}
        />
      )}
      {!isEditing && (
        <GroupRowView
          toggleEditGroup={() => setIsEditing(!isEditing)}
          group={group}
          position={position}
        />
      )}
    </>
  );
}
